module.exports = __webpack_public_path__ + "img/popover-header.dd35069a.png";